import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  titleCheckboxLabel: {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.primary,
  },
  sliderVerticalWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    height: '220px',
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(1.5),
  },
  gradientBar: {
    width: '18px',
    height: '180px',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
    transition: 'opacity 0.2s ease-in-out',
  },
  skinGradient: {
    background: 'linear-gradient(to top, #A52A2A, #f4a460, white, #964B00, black)',
  },
  eyeGradient: {
    background: 'linear-gradient(to top, #4682b4, #3b7a57, #c19a6b,  #6e4f34, #0a0a0a)',
  },
  enabledGradient: {
    opacity: 1,
  },
  disabledGradient: {
    opacity: 0.3,
  },
  sliderVertical: {
    height: '180px',
  },
  sliderVerticalContainer: {
    height: '180px',
    display: 'flex',
    alignItems: 'center',
  },
  formControl: {
    paddingLeft: theme.spacing(1.5),
    width: '100%',
  },
  divider: {
    margin: theme.spacing(3, 0, 2, 0),
  },
  imageScaleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
  },
  scaleImage: {
    maxWidth: '100%',
    borderRadius: '8px',
    boxShadow: theme.shadows[1],
    transition: 'opacity 0.2s ease-in-out, filter 0.2s ease-in-out',
  },
  scaleImageEnabled: {
    opacity: 1,
  },
  scaleImageDisabled: {
    opacity: 0.4,
    filter: 'grayscale(50%)',
  },
  sliderHorizontalContainer: {
    width: '100%',
    maxWidth: '600px',
    padding: theme.spacing(0, 2),
  },
  hairColorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing(2),
    minHeight: '200px',
    justifyContent: 'center',
    paddingLeft: theme.spacing(1.5),
  },
  colorPickerHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  radioGroupGrid: {
    paddingLeft: theme.spacing(1.5),
  },
  sliderScaleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
  },
  sliderHorizontalWrapper: {
    width: '100%',
    maxWidth: '280px',
    padding: theme.spacing(0, 1),
  },
  scaleImageHair: {
    width: '100%',
    maxWidth: '280px',
    height: 'auto',
    borderRadius: '4px',
    boxShadow: theme.shadows[1],
    transition: 'opacity 0.2s ease-in-out',
  },
  sliderScaleVerticalWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(1.5),
    height: '110px',
  },
  scaleImageVertical: {
    height: '110px',
    width: 'auto',
    objectFit: 'contain',
    borderRadius: '4px',
    transition: 'opacity 0.2s ease-in-out',
  },
}))
